import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-economics-program-tips',
  templateUrl: './bsc-economics-program-tips.component.html',
  styleUrls: ['./bsc-economics-program-tips.component.scss']
})
export class BscEconomicsProgramTipsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
